import { useState } from 'react';
import { EditorState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import EditorToolbar, { formats } from '../../utils/EditorToolbar';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Notif from '../../assets/icons/Notif';
import Button from '../../components/Button/Button';
import { saveQuizContent } from '../../services/handleImage';
import RadioChecked from '../../assets/icons/RadioChecked';
import { notification } from 'antd';

const Quiz = ({
  setContentType,
  id,
  contentType,
  quizActivity,
  quizTitle,
  sn,
}) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [loading, setLoading] = useState(false);
  const [effect, setEffect] = useState(false);

  const [questions, setQuestions] = useState([
    {
      id: 1,
      description: '',
      options: [
        {
          description: '',
          is_correct: false,
        },
        {
          description: '',
          is_correct: false,
        },
        {
          description: '',
          is_correct: false,
        },
        {
          description: '',
          is_correct: false,
        },
      ],
    },

    {
      id: 2,
      description: '',
      options: [
        {
          description: '',
          is_correct: false,
        },
        {
          description: '',
          is_correct: false,
        },
        {
          description: '',
          is_correct: false,
        },
        {
          description: '',
          is_correct: false,
        },
      ],
    },
  ]);

  const saveQuiz = async () => {
    let { school } = JSON.parse(localStorage.getItem('userData'));
    let course = JSON.parse(localStorage.getItem('course'));
    let topic = JSON.parse(localStorage.getItem('topic'));
    let id = JSON.parse(localStorage.getItem(`lesson${sn}`));
    if (!quizTitle) {
      notification['error']({
        message: 'Quiz title is required',
      });

      return;
    }

    if (!id) {
      notification['error']({
        message: 'Please save lesson title to proceed',
      });

      return;
    }

    try {
      setLoading(true);

      let res = await saveQuizContent(
        sn + 1,
        quizTitle,
        90,
        'quiz',
        'true',
        questions,
        school.id,
        course.id,
        topic.id,
        id
      );
      setLoading(false);
      notification['success']({
        message: 'Quiz content uploaded successfully',
      });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const saveQuestionToState = (id, e) => {
    let questionsCopy = [...questions];
    let newQuestions = questionsCopy.map((el) => {
      if (el.id === id) {
        return { ...el, description: e.target.value };
      }
      return el;
    });

    setQuestions(newQuestions);
  };

  const saveOptionToState = (id, e, optionId) => {
    let updatedOptions = questions[id].options.map((el, idx) => {
      if (idx === optionId) {
        return { ...el, description: e.target.value };
      }
      return el;
    });

    let newQuestions = questions.map((el) => {
      if (el.id === id + 1) {
        return { ...el, options: updatedOptions };
      }

      return el;
    });

    setQuestions(newQuestions);
  };

  const toggleTrueOrFalseOption = (questionId, optionId) => {
    console.log(questionId);
    let updatedOptions = questions[questionId].options.map((option, idx) => {
      if (idx === optionId) {
        return {
          ...option,
          is_correct: option.is_correct === true ? false : true,
        };
      } else {
        return {
          ...option,
          is_correct: false,
        };
      }
    });

    //update single question
    let updatedQuestion = questions.map((question, idx) => {
      if (questionId + 1 === question.id) {
        console.log({
          ...question,
          options: updatedOptions,
        });
        return {
          ...question,
          options: updatedOptions,
        };
      }
      return question;
    });

    //update questions in state

    questions[questionId].options = updatedOptions;
    setEffect(!effect);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {questions.map((el, idx) => (
        <div className='quiz-section'>
          <>
            <p style={{ marginBottom: '8px' }}>Question {idx + 1}</p>
            <div className='add-course__text-editor'>
              <textarea onBlur={(e) => saveQuestionToState(idx + 1, e)} />
            </div>
          </>
          <p style={{ margin: '16px 0' }}>Answers</p>
          {el?.options?.map((option, id) => (
            <div key={id}>
              <div
                className='add-course__text-editor'
                style={{ marginBottom: '16px' }}
              >
                <div className='flex'>
                  <div onClick={() => toggleTrueOrFalseOption(idx, id)}>
                    {option.is_correct ? (
                      <RadioChecked />
                    ) : (
                      <div className='answer-selection'>
                        <div className={'answer-selection__option'}></div>
                      </div>
                    )}
                  </div>

                  <div style={{ width: '100%' }}>
                    <input
                      type='text'
                      name='option'
                      onBlur={(e) => saveOptionToState(idx, e, id)}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}

          <div className='notif'>
            <Notif />
            <p>Select the correct answer to the question</p>
          </div>
        </div>
      ))}
      <div className='quiz-btn flex'>
        <p
          onClick={() =>
            setContentType(contentType.filter((el, idx) => idx !== id))
          }
        >
          Cancel
        </p>
        <Button
          text={loading ? 'Saving...' : `Save Quiz`}
          className='orange-border'
          onClick={() => {
            saveQuiz();
          }}
          disabled={loading}
        />
      </div>

      <div
        className='add-more'
        style={{ marginTop: '24px' }}
        onClick={() => {
          setQuestions([
            ...questions,
            {
              id: questions.length + 1,
              description: '',
              options: [
                {
                  description: '',
                  is_correct: false,
                },
                {
                  description: '',
                  is_correct: false,
                },
                {
                  description: '',
                  is_correct: false,
                },
                {
                  description: '',
                  is_correct: false,
                },
              ],
            },
          ]);
        }}
      >
        {' '}
        <svg
          width='14'
          height='14'
          viewBox='0 0 14 14'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z' fill='#FEA82F' />
        </svg>
        <p>Add Another Question</p>
      </div>
    </div>
  );
};

export default Quiz;
